import '../styles/main.styl';

import { initSwiper } from './components/swiper';
import { initMap } from './components/maps';
import { initUnit } from './components/unit';

document.addEventListener("DOMContentLoaded", function() {

    const bodyElement = document.getElementById("body");
    if (bodyElement) bodyElement.classList.add("body--loaded");

    // SWIPER
    initSwiper();

    
    // Google Maps
    setTimeout(function(){
        // Units
        initUnit();
        initMap();
    },600)


});

const startMap = function(){
    initMap();
}

